<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import { parseTime } from '@/utils/ruoyi'
import { pageUser, countryListUser } from '@/api/biz/user'
import { listLevel } from '@/api/user/level'

export default {
  name: 'UserSelectTable',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable', 'sys_notice_status', 'sys_user_sex'],
  data() {
    return {
      list: [],
      levelList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: '',
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        mobile: undefined,
        nickName: undefined,
        levelId: undefined,
        country: undefined,
        orderStartTime : undefined,
        orderEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户ID'),
          dataIndex: 'id',
          align: 'center',
          width: '180px',
          fixed: 'left'
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
          width: '180px',
          fixed: 'left'
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          width: '120px',
          align: 'center'
        },
        {
          width: '150px',
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('生日'),
          dataIndex: 'birthday',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('国家'),
          dataIndex: 'country',
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('个人简介'),
          dataIndex: 'introduction',
          width: '180px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户等级'),
          dataIndex: 'levelName',
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('下单次数'),
          dataIndex: 'orderTotalCount',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('下单总金额'),
          width: '180px',
          dataIndex: 'orderTotalAmount',
          align: 'center'
        },
        {
          title: this.$t('积分值'),
          dataIndex: 'score',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('用户余额'),
          dataIndex: 'balance',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('注册渠道'),
          dataIndex: 'registerChannel',
          scopedSlots: { customRender: 'registerChannel' },
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('用户状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('最后登录时间'),
          dataIndex: 'lastLoginTime',
          scopedSlots: { customRender: 'lastLoginTime' },
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('注册时间'),
          width: '180px',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ],
      visible: false,
      ids: [],
      countryList: [],
      // 下单时间区间
      orderTimeRange: []
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    // 打开弹窗
    open() {
      this.visible = true
      this.getCountryList()
      this.getLevelList()
      this.resetQuery()
      this.handleQuery()
    },
    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 确定选择
    handleOk() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t('请至少选择一个用户'))
        return
      }
      this.$emit('okData', this.selectedRows)
      this.$emit('ok', this.ids)
      this.handleClose()
    },
    parseTime,
    moment,
    getTotal(total) {
      return `total ${total} records`
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getCountryList() {
      countryListUser().then(response => {
        this.countryList = response.data
      })
    },
    /** 查询等级列表 */
    getLevelList() {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        mobile: undefined,
        nickName: undefined,
        levelId: undefined,
        country: undefined,
        orderStartTime: undefined,  // ✅ 清空
        orderEndTime: undefined,    // ✅ 清空
        pageNum: 1,
        pageSize: 10
      }
      this.orderTimeRange = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
      this.ids = this.selectedRows.map(item => item.id)
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    handleSelectAll() {
      const ids = this.list.map(item => item.id)
      this.ids = ids
      this.selectedRowKeys = ids
    },
    handleUnselectAll() {
      this.ids = []
      this.selectedRowKeys = []
    },
    // 处理下单时间变化
    handleOrderTimeChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.queryParam.orderStartTime = dateStrings[0]
        this.queryParam.orderEndTime = dateStrings[1]
      } else {
        this.queryParam.orderStartTime = undefined
        this.queryParam.orderEndTime = undefined
      }
    }
  }
}
</script>

<template>
  <a-modal
    title="Select User"
    :visible="visible"
    :width="1200"
    @cancel="handleClose"
    @ok="handleOk"
  >
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="14">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('昵称')" prop="nickName">
                <a-input
                  v-model="queryParam.nickName"
                  :placeholder="$t('请输入昵称')"
                  allow-clear
                  @pressEnter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input
                  v-model="queryParam.mobile"
                  :placeholder="$t('请输入手机号')"
                  allow-clear
                  @pressEnter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户等级')" prop="levelId">
                <a-select
                  v-model="queryParam.levelId"
                  :placeholder="$t('请选择用户等级')"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in levelList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ $t(item.levelName) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('国家')" prop="country">
                <a-select
                  v-model="queryParam.country"
                  :placeholder="$t('请选择')"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in countryList"
                    :key="item"
                    :value="item"
                  >
                    {{ item.englishName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :label="$t('订单时间')">
                <a-range-picker
                  v-model="orderTimeRange"                  style="width: 100%"
                  :placeholder="[$t('开始时间'), $t('结束时间')]"
                  format="YYYY-MM-DD HH:mm:ss"
                  show-time
                  @change="handleOrderTimeChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="float: right">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('查询') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('重置') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="handleSelectAll">
          {{ $t('全选') }}
        </a-button>
        <a-button type="primary" @click="handleUnselectAll">
          {{ $t('取消选择') }}
        </a-button>
        <span>{{ $t('已选择') }}{{ ids.length }}{{ $t('条') }}</span>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'checkbox'
        }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%' }"
      >
        <template slot="avatar" slot-scope="text, record">
          <div style="width: 60px; height: 60px; overflow:hidden; display: flex; justify-content: center; align-items: center;">
            <img
              v-if="record.avatar"
              :src="record.avatar"
              style="width:60px;height:60px;cursor: pointer;"
              @click="handleRecordPreview(record.avatar)"
              alt="avatar"
            />
          </div>
        </template>
        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex" />
        </span>
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <div slot="registerChannel" slot-scope="text, record">
          <span v-if="record.registerChannel === 'APP'">User APP</span>
        </div>
        <span slot="lastLoginTime" slot-scope="text, record">
          {{ parseTime(record.lastLoginTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="getTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 图片预览 -->
    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="preview" style="width: 100%" :src="previewUrl" />
    </a-modal>
  </a-modal>
</template>

<style scoped lang="less">
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
